import constants from 'constants';

const {
  LOAD_LANDING_DATA_SAGA,
  LOAD_ABOUT_DATA_SAGA,
  CREATE_LANDING_DATA_SAGA,
  CREATE_ABOUT_DATA_SAGA,
  LOAD_LANDING_DATA_USER_SAGA,
  LOAD_ABOUT_DATA_USER_SAGA,
  ADD_LANDING_DATA,
  ADD_ABOUT_DATA,
  ADD_LANDING_DATA_USER,
  ADD_ABOUT_DATA_USER
} = constants;

export const addLandingData = (data) => ({
  type: ADD_LANDING_DATA,
  payload: {
    data
  }
})

export const addLandingDataUser = (data) => ({
  type: ADD_LANDING_DATA_USER,
  payload: {
    data
  }
})

export const addAboutData = (data) => ({
  type: ADD_ABOUT_DATA,
  payload: {
    data
  }
})

export const addAboutDataUser = (data) => ({
  type: ADD_ABOUT_DATA_USER,
  payload: {
    data
  }
})

export const loadLandingDataSaga = () => ({
  type: LOAD_LANDING_DATA_SAGA
})

export const loadLandingDataUserSaga = () => ({
  type: LOAD_LANDING_DATA_USER_SAGA
})

export const createLandingDataSaga = (data) => ({
  type: CREATE_LANDING_DATA_SAGA,
  data
})

export const loadAboutDataSaga = () => ({
  type: LOAD_ABOUT_DATA_SAGA
})

export const loadAboutDataUserSaga = () => ({
  type: LOAD_ABOUT_DATA_USER_SAGA
})

export const createAboutDataSaga = (data) => ({
  type: CREATE_ABOUT_DATA_SAGA,
  data
})


// WEBPACK FOOTER //
// ./src/actions/landing.js